/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import { withReactBootstrap } from "@demant/react-bootstrap";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Select from "./select";
import { selectData } from "../utils/prop-types";
var SelectionSection = function SelectionSection(_ref) {
  var isDesktop = _ref.isDesktop,
    elements = _ref.elements,
    data = _ref.data,
    onChange = _ref.onChange,
    showDirect = _ref.showDirect,
    setDirect = _ref.setDirect,
    showTwoWayStreaming = _ref.showTwoWayStreaming,
    setTwoWayStreaming = _ref.setTwoWayStreaming,
    selectDeviceDictionary = _ref.selectDeviceDictionary,
    disableDirectStreaming = _ref.disableDirectStreaming,
    urlSelectedDeviceId = _ref.urlSelectedDeviceId,
    urlSelectedProductId = _ref.urlSelectedProductId,
    selectedProductId = _ref.selectedProductId,
    setSelectedProductId = _ref.setSelectedProductId,
    selectedDeviceId = _ref.selectedDeviceId,
    setSelectedDeviceId = _ref.setSelectedDeviceId;
  var cgSelection = document.getElementsByClassName("cg__selection");
  var isAdditionalFeatureData = elements.length > 4;
  useEffect(function () {
    setSelectedProductId(urlSelectedProductId);
    setSelectedDeviceId(urlSelectedDeviceId);
  }, [urlSelectedDeviceId, urlSelectedProductId]);
  useEffect(function () {
    onChange(selectedProductId, selectedDeviceId);
  }, [selectedProductId, selectedDeviceId]);
  var handleSelectChange = function handleSelectChange(event) {
    if (!isDesktop) {
      cgSelection[0].scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
    if (event.target.id === "products") {
      setSelectedProductId(parseInt(event.target.value, 10));
    } else if (event.target.id === "devices") {
      setSelectedDeviceId(event.target.value);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, data && elements.length > 0 && /*#__PURE__*/React.createElement(Select, {
    disableDirectStreaming: disableDirectStreaming,
    showDirect: showDirect,
    setDirect: setDirect,
    selectDeviceDictionary: selectDeviceDictionary,
    type: "products",
    dictionary: elements[0].taggedItems,
    data: data[0],
    onChange: handleSelectChange,
    value: selectedProductId
  }), data && elements.length > 1 && /*#__PURE__*/React.createElement(Select, {
    disableDirectStreaming: disableDirectStreaming,
    showDirect: showDirect,
    setDirect: setDirect,
    selectDeviceDictionary: selectDeviceDictionary,
    type: "devices",
    dictionary: elements[1].taggedItems,
    data: data[1],
    onChange: handleSelectChange,
    value: selectedDeviceId,
    hideCheckbox: isAdditionalFeatureData
  }), data && isAdditionalFeatureData && /*#__PURE__*/React.createElement(Select, {
    disableDirectStreaming: disableDirectStreaming,
    showDirect: showDirect,
    setDirect: setDirect,
    selectDeviceDictionary: elements[4],
    showTwoWayStreaming: showTwoWayStreaming,
    setTwoWayStreaming: setTwoWayStreaming,
    type: "additionalFeature",
    dictionary: elements[4].taggedItems,
    data: data[4],
    onChange: handleSelectChange,
    value: selectedDeviceId
  }));
};
SelectionSection.propTypes = {
  elements: PropTypes.array.isRequired,
  data: PropTypes.arrayOf(selectData).isRequired,
  isDesktop: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  urlSelectedDeviceId: PropTypes.string.isRequired,
  urlSelectedProductId: PropTypes.number.isRequired
};
export default withReactBootstrap(SelectionSection);